import {
  getStaticPropsGenerator,
  getStaticPathsGenerator,
} from '@cinch-nx/landing-feature-jargon'

const path = 'jargon'

export const getStaticProps = getStaticPropsGenerator({
  path,
})

export const getStaticPaths = getStaticPathsGenerator(path)

export { JargonFeature as default } from '@cinch-nx/landing-feature-jargon'
